export function isEmpty(value) {
    if (Array.isArray(value)) return value.length === 0;
    if (value instanceof Map || value instanceof Set) return value.size === 0;
    if (value && typeof value === "object") return Object.keys(value).length === 0;
    return !value;
}